import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Row, Col} from 'reactstrap';
import SolicitacaoStore from "../stores/SolicitacaoStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";

const FILTROS = ["DATA_INICIAL", "DATA_FINAL", "TIPO_FILTRO_REL_SOLICITACOES", "SITUACAO_SOLICITACAO"];
const VALIDACOES = ["DATA_FINAL_12_MESES", "TIPO_FILTRO_REL_SOLICITACOES_OBRIGATORIA"];

@inject("store")
@DataWrapper
@observer
export class Solicitacao extends Component {
    constructor(props) {
        super(props);
        this.controller = new SolicitacaoStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Solicitações");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro history={this.props.history}
                                controller={this.controller}
                                location={this.props.location}
                                fields={FILTROS}
                                validations={VALIDACOES}
                                onExportExcel={(filtro) => this.controller.onExportExcel(filtro)} />
                    </LoadingBlockFields>
                    {this.controller.erro &&
                        <MensagemErro>
                            {this.controller.erro}
                        </MensagemErro>
                    }
                </div>
            </div>
        )
    }
}
